import SideBar from "../../components/sidebar/sidebar";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Admin = () => {
  const { t } = useTranslation(["home"]);

  return (
    <div className="flex mt-16">
      <SideBar admin={true} title={t("Admin Dashboard")} />
      <main className="w-full overflow-scroll h-[85vh]">
        <Outlet />
      </main>
    </div>
  );
};
export default Admin;
